import { styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import { TextField, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import FONTS_FAMILY from "../../../theme/FontsFamily";
import VideoImage from '../../../assets/images/videoImage.png'


export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
});

export const HomeContainer = styled("div")((props) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  minHeight: "90vh",
  //paddingTop:'300px',
  // paddingBottom:'100px',
  background: `url(${props.image})`,
  backgroundSize: "cover",
  boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.5)",
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
}));

export const HomeCenterContent = styled("div")((props) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '600px',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const ContainerSection = styled("div")(props => ({
  display: "flex",
  flexDirection: "row",


  width: "100%",
  maxWidth: '1920px',
  alignSelf: 'center',
  //minHeight: "60vh",

}));


export const ContainerImg = styled("div")(props => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "50%",
  minHeight: "100%",
  justifyContent: "center",
  backgroundImage: `url(${props.image})`,
  boxShadow: "inset 0 0 0 2000px rgba(0,255,0,0.3)",
  MozUserSelect: 'none',
  "@media (min-width:360px)": {

  },
  "@media (min-width:768px)": {

  },
  "@media (min-width:1200px)": {

  },
}));

export const ContainerContacto = styled("div")({
  backgroundColor: COLORS.snow,

  width: '50%',

  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  "@media (min-width:360px)": {
    padding: '25px 0 25px 0',

  },
  "@media (min-width:768px)": {
    minHeight: "300px",

    padding: '10px',

  },
  "@media (min-width:1200px)": {
    padding: '45px'
  },

})

export const MediumContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  "@media (min-width:360px)": {
    minHeight: "270px",
  },
  "@media (min-width:768px)": {
    minHeight: "300px",
  },
  "@media (min-width:1200px)": {
    minHeight: "600px",
  },
});

export const MottoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  backgroundColor: COLORS.white,
  "@media (min-width:360px)": {
    minHeight: "190px",
  },
  "@media (min-width:768px)": {
    minHeight: "200px",
  },
  "@media (min-width:1200px)": {
    minHeight: "220px",

  },
});
export const LetterContainer = styled("div")({
  marginBottom: "10px",
  textAlign: "center",
  "@media (min-width:360px)": {
    width: "100%",
    textAlign: 'center'
  },
  "@media (min-width:768px)": {
    width: "100%",


  },
  "@media (min-width:1200px)": {
    width: "90%",

  },
});

export const DownContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  backgroundColor: COLORS.white,
  "@media (min-width:360px)": {
    minHeight: "110px",
  },
  "@media (min-width:768px)": {
    minHeight: "150px",
  },
  "@media (min-width:1200px)": {
    minHeight: "1px",
  },
});

export const HomeTextContainer = styled("div")({
  display: 'flex',
  flexDirection: "column",
  position: "relative",
  marginLeft: "17%",

  height: "500px",
  alignSelf: "center",
  fontSize: "15px",
  width: "70%",
  justifyContent: 'center',
  /*
  display:'flex',
  flexDirection:'column',
  height:'300px',
  alignItems:'center',
  justifyContent:'center'
  */

});

export const DefaultButton = styled(Button)({
  color: COLORS.white,
  backgroundColor: COLORS.primary,
  borderRadius: "17px",
  fontSize: "15px !important",
  height: '38px',
  fontFamily: FONTS_FAMILY.bold.title,
  "&:hover,&:focus,&:active": {
    color: COLORS.white,
    backgroundColor: COLORS.grayHover,
  },
  "@media (min-width:320px)": {

    width: "170px",
  },
  "@media (min-width:768px)": {

    width: "210px",
  },
  "@media (min-width:1200px)": {

    width: "230px",
  },
});

export const HomeTitle = styled("h1")({
  fontFamily: FONTS_FAMILY.bold.body,
  zIndex: 10,
  width: "55%",
  color: COLORS.white,
  textAlign: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  "@media (min-width:320px)": {
    fontSize: "25px",
    height: "280px",
    WebkitLineClamp: 8, /* number of lines to show */
  },
  "@media (min-width:768px)": {
    fontSize: "30px",
    WebkitLineClamp: 6, /* number of lines to show */
    height: "250px",
  },
  "@media (min-width:1200px)": {
    fontSize: "60px",
    height: "200px",
    WebkitLineClamp: 5, /* number of lines to show */
  },
});





export const Section = styled("section")({
  marginBlock: "0.67em",
  overflowX: "",
  position: "absolute",
  display: "inline-block",
  top: "30%",
  left: "20%",
  zIndex: 30,
  justifyContent: "center",
  flexDirection: "column",
  /* test*/
  height: "500px",
  textDecoration: "none",
  minHeight: "300px",
  width: "50%",
  "@media (max-width:360px)": {
    fontSize: "8px",
    display: "block",
  },
  "@media (min-width:768px)": {
    fontSize: "14px",
    top: "30%",
    left: "20%",
  },
  "@media (min-width:1200px)": {
    fontSize: "18px",
  },
  "@media (min-width:2048px)": {
    fontSize: "30px",
  },
  "@media (min-width:3840px)": {
    fontSize: "55px",
  },
});

export const StyledDescriptionIcon = styled(DescriptionIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const StyledPersonAddIcon = styled(PersonAddIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const StyledSearchIcon = styled(SearchIcon)({
  color: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "50px",
  },
  "@media (min-width:768px)": {
    fontSize: "70px",
  },
  "@media (min-width:1200px)": {
    fontSize: "100px",
  },
});

export const Title = styled("h1")({
  margin: '10px',

  textAlign: 'center',
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.regular.title,

  fontWeight: 400,
  lineHeight: ' 1.5',
  "@media (min-width:320px)": {
    fontSize: "22px",
  },
  "@media (min-width:768px)": {
    fontSize: "40px",
  },
  "@media (min-width:1200px)": {
    fontSize: "50px",
  },
});

export const SubTitle = styled("h3")({
  margin: 0,
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.bold.title,
  "@media (min-width:320px)": {
    fontSize: "15px",
  },
  "@media (min-width:768px)": {
    fontSize: "18px",
  },
  "@media (min-width:1200px)": {
    fontSize: "20px",
  },
});

export const SearcherSubTitle = styled("p")({
  color: COLORS.secondary,
  textAlign: "center",
  marginBottom: "10px",
  alignSelf: 'center',
  fontFamily: FONTS_FAMILY.regular.body,
  "@media (min-width:320px)": {
    fontSize: "15px",
    width: '350px',
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
    width: '500px',
  },
  "@media (min-width:1200px)": {
    fontSize: "16px",
    width: '700px',
  },
});

export const SearcherTitle = styled("h3")({
  color: COLORS.secondary,
  margin: "0",
  textAlign: "center",
  fontSize: "30px",
  fontFamily: FONTS_FAMILY.regular.title,
  "@media (max-width:768px)": {
    fontSize: "23px",
  },
});

export const AnalyticsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignSelf: "center",
  width: "100%",
  justifyContent: "space-evenly",
  maxWidth: "1920px",
});


export const InfoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "83%",
  alignItems: "flex-start",
  alignSelf: "center",
});

export const SearcherContainer = styled("div")({
  borderRadius: '10px',
  "@media (min-width:320px)": {
    width: '300px',
  },
  "@media (min-width:768px)": {
    width: '600px',
  },
  "@media (min-width:1200px)": {
    width: '800px',
  },
});

export const SelectorContainer = styled("div")({
  width: "100%",
  alignItems: "flex-start",
  alignSelf: "center",
  padding: "1%",
});

export const SelectorsSearcherContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignSelf: "center",
  width: "85%",
  justifyContent: "space-evenly",
  "@media (max-width:830px)": {
    flexDirection: "column",
  },
});

export const StyledSearchIconForSearcher = styled(SearchIcon)({
  color: COLORS.white
});

export const SearchTextInput = styled(TextField)({
  width: '100%',
  alignSelf: 'center',
  borderWidth: '5px',
  color: COLORS.white,
  // backgroundColor:COLORS.white,
  '& .MuiInputBase-input ': {
    width: '100%',
    fontSize: '17px',
    //   backgroundColor: COLORS.white,
    padding: 10,
    color: COLORS.white,
    '&::placeholder': {
      color: `${COLORS.white} !important`
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: COLORS.white,
      borderRadius: '50px',
      minHeight: '45px',
      color: COLORS.white,
    },
    '&:hover fieldset': {
      borderColor: COLORS.white,
      color: COLORS.white,
    },
    '&.Mui-focused fieldset': {
      borderColor: COLORS.white,
      borderWidth: '1px',
    },

  },
});

export const SearchSelect = styled(TextField)({
  alignSelf: "start",
  width: "100%",
  "& .MuiMenuItem-root": {
    fontSize: "100px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: COLORS.secondary,
      borderRadius: 0,
    },
    "&:hover fieldset": {
      borderColor: COLORS.secondary,
      borderRadius: 0,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.secondary,
      borderWidth: "1px",
      borderRadius: 0,
    },
  },
  "@media (max-width:830px)": {
    width: "100%",
    paddingBottom: "5px",
  },
});

export const ServicesListContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  width: "100%",
  minHeight: "100vh",
});

export const WhiteTitle = styled("h1")({
  //margin: "10px",
  fontSize: "50px",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.bold.title,
  "@media (min-width:320px)": {
    fontSize: "40px",
  },
  "@media (min-width:768px)": {
    fontSize: "50px",
  },
  "@media (min-width:1200px)": {
    fontSize: "60px",
  },
});

export const WhiteSubtitle = styled("h1")({
  margin: "10px",
  fontSize: "20px",
  textAlign: "center",
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.bold.title,
  //  textShadow: '2px 2px 10px #000000',
  "@media (max-width:768px)": {
    fontSize: "20px",
  },
});

export const CenterContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "85%",
  maxWidth: "1920px",
  alignSelf: "center",
  padding: "10px",
});

export const CardsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  "@media (min-width:320px)": {
    flexDirection: "column",
  },
  "@media (min-width:768px)": {
    flexDirection: "row",
    
  },
  "@media (min-width:1200px)": {
    flexDirection: "row",
  },
});

export const CardsDivider = styled("div")({
  "@media (min-width:320px)": {
    height: "25px",
  },
  "@media (min-width:768px)": {
    width: "10%",
  },
  "@media (min-width:1200px)": {
    width: "10%",
  },
});

export const ContactContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  justifyContent: "center",
  backgroundColor: COLORS.white,
  "@media (min-width:360px)": {
    minHeight: "200px",
  },
  "@media (min-width:768px)": {
    minHeight: "250px",
  },
  "@media (min-width:1200px)": {
    minHeight: "300px",
  }
});

export const TextSuport = styled("span")({
  marginTop: '0.1%',
  fontFamily: FONTS_FAMILY.regular.body,
  fontSize: '18px',
  color: COLORS.secondary,



})



export const FootersDivider = styled("div")({
  "@media (min-width:320px)": {
    height: "25px",
  },
  "@media (min-width:768px)": {
    width: "10%",
  },
  "@media (min-width:1200px)": {
    width: "10%",
  },
});

export const MottoText = styled("p")({
  color: 'gray',
  fontFamily: FONTS_FAMILY.regular.body,
  textAlign: 'center',
  alignSelf: 'center',
  width: '60%',
  fontSize: "20px",
});

export const MottoLinkText = styled("a")({
  fontFamily: FONTS_FAMILY.regular.body,
  color: COLORS.primary,
  fontWeight: '600',
  fontSize: '20px',
  textAlign: 'center',
  alignSelf: 'center',
  width: '60%',
});

export const SubtitleContactanos = styled("h3")({
  fontSize: '1rem',

  top: '1%',
  color: COLORS.white,
  fontFamily: FONTS_FAMILY.medium.body,
  letterSpacing: '.2rem',
  fontWeight: 400,
  lineHeight: ' 1.5',

  "@media (min-width:320px)": {
    fontSize: "16px",
  },
  "@media (min-width:768px)": {
    fontSize: "16px",
  },
  "@media (min-width:1200px)": {
    fontSize: "20px",
  },
});

export const DirectionTitle = styled("h3")({
  color: COLORS.secondary,
  margin: "0",
  textAlign: "center",
  fontSize: "30px",
  fontFamily: FONTS_FAMILY.regular.title,
  "@media (max-width:768px)": {
    fontSize: "23px",
  },
});


export const DirectionSubTitle = styled("p")({
  color: COLORS.secondary,
  textAlign: "center",
  marginBottom: "10px",
  alignSelf: 'center',
  fontFamily: FONTS_FAMILY.regular.body,
  "@media (min-width:320px)": {
    fontSize: "15px",
    width: '350px',
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
    width: '500px',
  },
  "@media (min-width:1200px)": {
    fontSize: "16px",
    width: '700px',
  },
});

export const LogoImage = styled("img")({

  margin: "20px",
  color: 'white',
  "@media (min-width:320px)": {
    width: "100px",
  },
  "@media (min-width:768px)": {
    width: "150px",
  },
  "@media (min-width:1200px)": {
    width: "250px",
  },
  userDrag: 'none',
  userSelect: 'none',
  '-moz-user-select': 'none',
  '-webkit-user-drag': 'none',
  '-webkit-user-select': 'none',
  '-ms-user-select': 'none',
});

export const ContainerVideo = styled("div")(props => ({
  position: 'relative',
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: '1920px',
  alignSelf: 'center',
  minHeight: "100vh",
  justifyContent: "center",
}));


export const VideoOverlay = styled("div")(props => ({
  position: 'absolute',
  backgroundImage: `url(${VideoImage})`,
  display: props.display,
  flexDirection: "column",
  width: "100%",
  maxWidth: '1920px',
  alignSelf: 'center',
  minHeight: "100vh",
  justifyContent: "center",
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  "&:hover": {
    cursor: 'pointer',
    boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.1)",
  },
}));
